<template>
  <v-stepper-content v-bind="$attrs">
    <v-card>
      <v-card-title>
        Выберите дилера
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          color="green"
          :value="value"
          @change="e => $emit('input', e)"
          :items="filtered_dealers"
          no-data-text="Нет данных"
        >

        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="$emit('next')"
          color="green"
          text
          :disabled="value == 0"
        >
          <v-icon small>mdi-page-next-outline</v-icon>
          Далее
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props:['value'],
  computed:{
    ...mapGetters(['dealers']),
    filtered_dealers(){
      return this.dealers.filter( el => !el.isDeleted).map( el => {
        return {
          text: `(${el.id}) ${el.name}`,
          value: el.id
        }
      })
    }
  }
}
</script>